import type { OptionsParams } from 'fe-be-utils';
import { Button } from '../ui/button';

type OptionsComponentProps = {
  params: OptionsParams;
  onSubmit: (value: string) => void;
  onDismiss: () => void;
  accentColor?: string;
  textOverAccentColor?: string;
};

export const OptionsComponent = ({ params, onSubmit, onDismiss }: OptionsComponentProps) => {
  return (
    <div className="mb-3 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900">
      <p className="mb-3 whitespace-pre-line text-sm text-gray-700 dark:text-gray-300">{params.prompt}</p>
      <div className="flex flex-col gap-2">
        {params.options.map((option) => (
          <Button
            key={option.value}
            variant="outline"
            size="sm"
            onClick={() => onSubmit(option.value)}
            className="text-xs bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-100 text-center justify-center h-auto py-2 px-3 rounded-full whitespace-normal break-words min-w-0 max-w-full shadow-sm"
          >
            {option.label}
          </Button>
        ))}
      </div>
      <div className="mt-3">
        <Button variant="ghost" size="sm" onClick={onDismiss}>
          Skip
        </Button>
      </div>
    </div>
  );
};
